/**
 * Cornerstone bilingual strings. Use t('key') from useI18n().
 */
export const STRINGS = {
  pt: {
    // App / nav
    app_name: "Cornerstone",
    by_company: "por GT Strategy",
    nav_dashboard: "Painel",
    nav_projects: "Projetos",
    nav_settings: "Configurações",
    nav_users: "Usuários",
    nav_logout: "Sair",
    language: "Idioma",
    portuguese: "Português",
    english: "English",
    // Auth
    login_title: "Acessar Cornerstone",
    login_subtitle: "Gestão de cronogramas para projetos de construção.",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    company_name: "Nome da Empresa",
    login_submit: "Entrar",
    register_submit: "Criar Conta",
    no_account: "Não tem conta?",
    have_account: "Já tem conta?",
    sign_up: "Cadastre-se",
    sign_in: "Entrar",
    register_title: "Criar nova conta",
    register_subtitle: "Comece a planejar seus projetos em minutos.",
    // Dashboard
    dashboard_title: "Painel",
    dashboard_subtitle: "Visão geral dos seus projetos.",
    total_projects: "Projetos",
    total_syncs: "Versões",
    total_tasks: "Tarefas",
    open_restrictions: "Restrições Abertas",
    new_project: "Novo Projeto",
    recent_projects: "Projetos Recentes",
    no_projects: "Nenhum projeto ainda. Crie seu primeiro projeto para começar.",
    // Projects
    projects_title: "Projetos",
    create_project: "Criar Projeto",
    project_name: "Nome do Projeto",
    description: "Descrição",
    location: "Localização",
    client: "Cliente",
    start_date: "Data Início",
    end_date: "Data Fim",
    status: "Status",
    color: "Cor",
    cancel: "Cancelar",
    save: "Salvar",
    create: "Criar",
    open: "Abrir",
    delete: "Excluir",
    edit: "Editar",
    confirm_delete: "Confirma a exclusão? Esta ação não pode ser desfeita.",
    // Project detail
    overview: "Visão Geral",
    syncs: "Versões",
    gantt: "Gantt",
    kanban: "Kanban",
    line_of_balance: "Linha de Balanço",
    restrictions: "Restrições",
    sharepoint: "SharePoint",
    project_settings: "Configurações",
    setup_progress: "Progresso da Configuração",
    next_step: "Próximo Passo",
    completed: "concluído",
    of: "de",
    // Syncs
    upload_schedule: "Importar Cronograma",
    drop_files: "Solte o arquivo aqui ou clique para selecionar (.xml, .csv, .mpp)",
    sync_name: "Nome da Versão",
    set_baseline: "Marcar como Baseline",
    sync_reparse_tooltip: "Reprocessar arquivo · re-roda o parser e re-popula custom fields (útil depois de upgrades do parser)",
    sync_sharepoint_link_tooltip: "Abrir arquivo original no SharePoint",
    sync_rename_tooltip: "Renomear versão",
    incomplete_versions_singular: "versão parece incompleta após upgrade do parser:",
    incomplete_versions_plural: "versões parecem incompletas após upgrade do parser:",
    incomplete_breakdown_empty: "sem tarefas (importadas antes do suporte nativo a .mpp)",
    incomplete_breakdown_cf_regression: "com colunas customizadas perdidas (regressão JVM iter30)",
    incomplete_breakdown_missing_aliases: "sem aliases de colunas (uploads legacy)",
    reparse_all_incomplete_btn: "Reprocessar todas",
    reparse_project_tooltip: "Reprocessar todas as versões deste projeto · re-roda o parser em cada upload (.mpp/.xml/.csv) ou re-baixa do SharePoint se o arquivo local sumiu",
    reparse_company_btn: "Reprocessar tudo",
    reparse_company_tooltip: "Reprocessar TODAS as versões de TODOS os projetos desta empresa (super-admin / admin only)",
    confirm_reparse_project: "Reprocessar todas as versões do projeto \"{name}\"? Pode levar alguns minutos.",
    confirm_reparse_company: "Reprocessar TODAS as versões de TODOS os projetos de \"{name}\"? Pode levar bastante tempo dependendo do volume.",
    reparse_project_done: "{ok}/{total} versões do projeto reprocessadas",
    reparse_company_done: "{ok}/{total} versões da empresa reprocessadas",
    failed: "falharam",
    notes: "Observações",
    no_syncs: "Nenhuma versão de cronograma ainda. Importe seu primeiro arquivo para começar.",
    version: "Versão",
    tasks: "tarefas",
    baseline: "Baseline",
    uploaded_by: "Importado por",
    compare_versions: "Comparar Versões",
    select_baseline: "Selecione Baseline",
    select_target: "Selecione Versão Alvo",
    // Gantt/Kanban/LoB
    no_tasks: "Nenhuma tarefa nesta versão.",
    pick_a_sync: "Selecione uma versão de cronograma à esquerda para visualizar.",
    not_started: "Não iniciada",
    in_progress: "Em andamento",
    late: "Atrasada",
    completed_status: "Concluída",
    critical_path: "Caminho Crítico",
    show_critical_only: "Apenas Críticas",
    // Restrictions
    add_restriction: "Nova Restrição",
    title: "Título",
    category: "Categoria",
    responsible: "Responsável",
    due_date: "Prazo",
    priority: "Prioridade",
    related_tasks: "Tarefas Relacionadas",
    no_restrictions: "Nenhuma restrição cadastrada.",
    // SharePoint
    sharepoint_config: "Configuração SharePoint",
    sharepoint_subtitle: "Conecte sua biblioteca de documentos para sincronização automática de cronogramas.",
    tenant_id: "Azure AD Tenant ID",
    client_id: "Client ID",
    client_secret: "Client Secret",
    hostname: "Hostname SharePoint",
    site_relative_url: "URL do Site",
    document_library: "Biblioteca de Documentos",
    file_path: "Caminho do Arquivo",
    folder_path: "Pasta dos Cronogramas",
    folder_path_help: "Caminho da pasta no SharePoint onde os arquivos .mpp/.xml/.csv estão salvos. Ex: /Cronogramas",
    include_subfolders: "Incluir Subpastas",
    browse_files: "Procurar Arquivos",
    browsing: "Buscando arquivos…",
    files_found: "arquivos encontrados",
    no_files_found: "Nenhum arquivo de cronograma (.mpp, .xml, .csv) encontrado nesta pasta.",
    select_files_to_import: "Selecione os arquivos para importar como versões de cronograma. Você pode renomeá-los antes da importação.",
    file_name: "Nome do Arquivo",
    rename_to: "Renomear para",
    size: "Tamanho",
    modified: "Modificado",
    import_selected: "Importar Selecionados",
    importing: "Importando…",
    already_imported: "Já importado",
    already_imported_short: "importados",
    collapse: "Recolher",
    expand: "Expandir",
    files_short: "arquivo",
    files_short_plural: "arquivos",
    selected: "selecionado(s)",
    select_all: "Selecionar Todos",
    deselect_all: "Desmarcar Todos",
    set_as_baseline_short: "Baseline",
    step_credentials_title: "Credenciais & Site",
    step_folder_title: "Pasta dos Cronogramas",
    step_files_title: "Mapeamento de Arquivos",
    company_sp_creds_title: "Credenciais SharePoint (Azure AD)",
    company_sp_creds_subtitle: "Cadastre uma vez por empresa. Será usado em todos os projetos.",
    library_url: "Link da Biblioteca SharePoint",
    library_url_help: "Cole o link da biblioteca ou da pasta no SharePoint. Ex: https://contoso.sharepoint.com/sites/Projetos/Cronogramas",
    parsed_preview: "Detectado",
    edit_credentials: "Editar Credenciais",
    not_configured: "Não configurado",
    configured: "Configurado",
    go_to_settings: "Ir para Configurações",
    sp_creds_missing_help: "As credenciais Azure AD da empresa precisam ser cadastradas antes de configurar qualquer projeto.",
    company_sp_creds_saved: "Credenciais Azure AD salvas com sucesso.",
    save_credentials: "Salvar Credenciais",
    auto_sync: "Sincronização Automática",
    interval_min: "Intervalo (minutos)",
    test_connection: "Testar Conexão",
    save_config: "Salvar Configuração",
    sp_help: "Para conectar com o SharePoint, registre uma aplicação no Azure AD (Entra ID). Após isso, preencha tenant_id, client_id e client_secret.",
    // Live sync
    step_autosync_title: "Sincronização ao Vivo",
    autosync_subtitle: "Cornerstone busca novos cronogramas e versões atualizadas direto da pasta no SharePoint.",
    autosync_enable: "Ativar sincronização automática",
    autosync_frequency: "Frequência",
    every: "A cada",
    unit_hours: "hora(s)",
    unit_days: "dia(s)",
    unit_months: "mês(es)",
    every_5_min: "A cada 5 minutos",
    every_15_min: "A cada 15 minutos",
    every_30_min: "A cada 30 minutos",
    every_hour: "A cada 1 hora",
    every_2_hours: "A cada 2 horas",
    every_6_hours: "A cada 6 horas",
    every_day: "A cada 24 horas",
    last_sync_at: "Última sincronização",
    next_sync_at: "Próxima sincronização",
    last_sync_summary: "Resumo",
    last_sync_error: "Erro",
    sync_now_btn: "Sincronizar agora",
    syncing_now: "Sincronizando…",
    syncing_in_progress: "Sincronização em andamento…",
    sync_files_new: "novos",
    sync_files_updated: "atualizados",
    sync_files_skipped: "inalterados",
    sync_files_failed: "falhas",
    sync_never_ran: "Ainda não executada",
    sync_success: "Sincronização concluída",
    sync_failed: "Falha na sincronização",
    sync_no_changes: "Nenhuma alteração detectada",
    sync_in_progress_msg: "Sincronização já em andamento. Aguarde a conclusão.",
    sync_label_active: "ativa",
    sync_label_inactive: "inativa",
    time_ago: "há {value}{unit}",
    time_in: "em {value}{unit}",
    // AI
    ai_analysis: "Análise IA",
    analyze: "Analisar",
    analyze_schedule_btn: "Analisar Cronograma com IA",
    ai_subtitle: "Insights gerados por Claude Sonnet 4.5",
    analysis_type: "Tipo de Análise",
    type_general: "Geral",
    type_critical: "Caminho Crítico",
    type_bottlenecks: "Gargalos",
    type_delays: "Atrasos",
    type_optimization: "Otimização",
    type_inconsistencies: "Inconsistências",
    summary: "Resumo",
    critical_tasks: "Tarefas Críticas",
    bottlenecks: "Gargalos",
    delays_at_risk: "Atrasos em Risco",
    optimization_suggestions: "Sugestões de Otimização",
    inconsistencies: "Inconsistências",
    key_metrics: "Métricas Chave",
    history: "Histórico",
    generating: "Gerando análise…",
    extra_context: "Contexto adicional (opcional)",
    // Sync compare
    sync_comparator: "Comparador de Versões",
    added: "Adicionadas",
    removed: "Removidas",
    delayed: "Atrasadas",
    accelerated: "Aceleradas",
    changed: "Alteradas",
    unchanged: "Sem alteração",
    from: "De",
    to: "Para",
    compare: "Comparar",
    compare_with_ai: "Comparar com IA",
    // Settings
    company_info: "Informações da Empresa",
    user_management: "Gestão de Usuários",
    invite_user: "Convidar Usuário",
    role: "Função",
    admin: "Admin",
    member: "Membro",
    // Empty
    loading: "Carregando…",
    error: "Erro",
    share_track_latest_label: "Sempre última versão",
    share_track_latest_help: "Adiciona automaticamente a versão mais recente sincronizada (SharePoint ou upload manual), além das versões fixas selecionadas.",
    share_include_all_label: "Todas as versões (automático)",
    share_include_all_help: "Expõe TODAS as versões deste projeto na API e no link público — inclusive as que forem criadas no futuro, sem precisar editar o link.",
    share_all_projects_label: "Todos os projetos (automático)",
    share_all_projects_help: "Este link passa a servir TODOS os projetos da empresa, inclusive os criados no futuro. Você pode continuar fixando versões específicas para projetos individuais abaixo.",
    share_all_projects_versions_label: "Servir todas as versões de cada projeto (em vez de apenas a última)",
    share_all_projects_badge: "Todos os projetos",
    share_all_versions_badge: "Todas as versões",
    share_effective_label: "Servindo agora",
    share_effective_empty: "Nenhuma versão disponível ainda",
    share_live_badge: "Ao vivo",
    share_live_badge_tooltip: "Este link sempre mostra a versão mais recente sincronizada deste projeto",
    success: "Sucesso",
    // Navigation (extras)
    nav_work_program: "Programação",
    nav_share_links: "Compartilhamento",
    nav_data: "Data",
    data_page_title: "Data Explorer",
    data_page_subtitle: "Todas as tarefas de todos os projetos e versões em uma tabela única. Filtre por link compartilhado, projeto ou colunas específicas. Selecione colunas numéricas nos cabeçalhos (com Σ) para ver totais.",
    data_admin_only: "Acesso restrito a admin da empresa.",
    data_filter_share_link: "Escopo por link compartilhado",
    data_filter_all_data: "Todos os dados",
    data_filter_exclude_share_links: "Excluir versões em links compartilhados",
    data_filter_project: "Projeto",
    data_filter_all_projects: "Todos os projetos",
    data_export_csv: "Exportar CSV",
    data_syncs_count: "versões",
    data_projects_count: "projetos",
    data_toggle_sum: "Clique para somar/média nesta coluna",
    no_data: "Nenhum dado encontrado com os filtros atuais.",
    clear_filters: "Limpar filtros",
    clear: "limpar",
    // Gantt — toolbar + zoom presets
    zoom_7d: "7 dias",
    zoom_15d: "15 dias",
    zoom_30d: "30 dias",
    zoom_1y: "1 ano",
    zoom_fit: "Ajustar",
    period: "Período",
    critical_path_short: "Crítica",
    columns: "Colunas",
    clear_filters: "Limpar filtros",
    clear_filters_title: "Limpar todos os filtros (colunas, período, crítica)",
    projects: "Projetos",
    comparing: "Comparando",
    saved_views_btn: "Visualizações",
    export_btn: "Exportar",
    versions_short: "v",
    // Gantt — column headers (canonical labels)
    col_task: "Tarefa",
    col_id: "ID",
    col_start: "Início",
    col_finish: "Término",
    col_duration_days: "Dur (d)",
    col_percent: "%",
    col_wbs: "EDT/WBS",
    col_outline_level: "Nível",
    col_is_summary: "Resumo",
    col_is_critical: "Crítica",
    col_milestone: "Marco",
    col_constraint_type: "Restrição",
    col_constraint_date: "Data Restrição",
    col_actual_start: "Início Real",
    col_actual_finish: "Término Real",
    col_actual_duration: "Duração Real",
    col_baseline_start: "Início Base",
    col_baseline_finish: "Término Base",
    col_baseline_duration: "Duração Base",
    col_work_complete: "% Trabalho",
    col_cost: "Custo",
    col_actual_cost: "Custo Real",
    col_free_slack: "Folga Livre",
    col_total_slack: "Folga Total",
    col_early_start: "Início Cedo",
    col_early_finish: "Término Cedo",
    col_late_start: "Início Tarde",
    col_late_finish: "Término Tarde",
    col_priority: "Prioridade",
    col_active: "Ativa",
    // Gantt — filters + footer
    filter_search_placeholder: "buscar…",
    filter_all: "todos",
    filter_selected_short: "selecionados",
    filter_select_all: "Selecionar visíveis",
    filter_clear: "Limpar",
    no_match: "Nenhum resultado",
    tasks_n: "tarefas",
    tasks_filtered_of: "filtradas de",
    tasks_total: "tarefas no total",
    empty_no_tasks_version: "Nenhuma tarefa nesta versão.",
    empty_no_tasks_selection: "Nenhuma tarefa nesta seleção.",
    // Gantt — diff bar
    diff_vs_base: "vs versão base:",
    diff_added: "Novas",
    diff_removed: "Removidas",
    diff_delayed: "Atrasadas",
    diff_accelerated: "Adiantadas",
    diff_clear: "limpar filtro ✕",
    // ColumnsPanel
    columns_panel_section: "visualização",
    columns_drag_hint: "arraste pelo ⋮⋮ para reordenar",
    columns_drag_handle_title: "Arraste para reordenar",
    columns_available_to_add: "Disponíveis para adicionar",
    columns_width_px_title: "Largura da coluna em pixels",
    // Saved Views menu
    saved_views_title: "Visualizações",
    saved_views_read_only_subtitle: "somente leitura · publicadas pela empresa",
    saved_views_name_placeholder: "Nome da visualização",
    saved_views_scope_user: "Apenas eu",
    saved_views_scope_company: "Toda empresa",
    saved_views_save: "Salvar",
    saved_views_empty: "Nenhuma visualização salva ainda.",
    saved_views_empty_public: "Nenhuma visualização publicada pela empresa ainda.",
    saved_views_loading: "Carregando…",
    saved_views_name_required: "Informe um nome",
    saved_views_saved: "Visualização salva",
    saved_views_loaded: "Carregado",
    saved_views_confirm_delete: "Excluir esta visualização?",
    saved_views_scope_label_company: "empresa",
    saved_views_scope_label_user: "usuário",
    export_title: "Exportar",
    export_csv_visible_title: "CSV — colunas visíveis",
    export_csv_visible_desc: "Apenas as colunas atualmente exibidas, todas as linhas filtradas.",
    export_csv_all_title: "CSV — todas as colunas",
    export_csv_all_desc: "Inclui colunas ocultas e campos customizados.",
    export_png_title: "Imagem PNG — Gantt completo",
    export_png_desc: "Exporta todas as linhas e o cronograma inteiro (off-screen), não apenas o trecho visível na tela.",
    export_csv_visible_suffix: "visivel",
    export_csv_all_suffix: "completo",
    export_failed_generic: "Falha ao gerar a imagem.",
    compare_title: "Comparar com versão",
    compare_help: "Sobrepõe a versão selecionada como sombra (linha tracejada). Use para visualizar atrasos/avanços versus baseline.",
    compare_project_label: "Projeto",
    compare_version_label: "Versão",
    compare_clear: "Remover",
    compare_apply: "Aplicar",
    task_predecessors: "Predecessoras",
    task_section_hierarchy: "Hierarquia",
    task_section_dates: "Datas",
    task_section_actuals: "Realizado",
    task_section_baseline: "Linha Base",
    task_section_cpm: "CPM / Folga",
    task_section_resources: "Recursos & Custos",
    task_section_meta: "Outros",
    task_section_custom: "Campos Customizados",
    task_section_label: "tarefa",
    yes_short: "Sim",
    no_short: "Não",
    multi_company_section: "multi-empresa",
    multi_company_pick_title: "Escolha sua empresa",
    multi_company_pick_help: "Seu usuário está vinculado a mais de uma empresa. Selecione com qual contexto deseja entrar.",
    super_admin_multi: "super-admin · multi-empresa",
    tenant_current: "tenant atual",
    shared_view_label: "compartilhamento",
    email_placeholder: "voce@empresa.com",
    day_short: "dia",
    maint_title: "Manutenção",
    maint_subtitle: "operações administrativas (admin only)",
    maint_recompute_title: "Recomputar ordenação das tarefas",
    maint_recompute_desc: "Re-numera o campo `seq` em cada tarefa usando o algoritmo tree-DFS, garantindo que a hierarquia (pai → filhos) apareça na ordem correta no Gantt e em links de compartilhamento. Operação idempotente — seguro re-executar.",
    maint_recompute_company_btn: "Recomputar (empresa atual)",
    maint_recompute_all_btn: "Recomputar TODAS as empresas",
    maint_confirm_company: "Recomputar a ordenação de TODAS as tarefas de TODOS os syncs desta empresa? Operação é segura e idempotente.",
    maint_confirm_all: "Recomputar a ordenação de TODAS as tarefas de TODAS as empresas? Esta é a operação cluster-wide — só super-admins.",
    maint_done: "{syncs} syncs processados · {tasks} tarefas atualizadas",
    maint_mpp_title: "Parser MPP (Microsoft Project)",
    maint_mpp_desc: "Para fazer upload de arquivos `.mpp` (formato binário do MS Project), o backend precisa da JVM (Java 17) + biblioteca MPXJ. Status detectado automaticamente.",
    maint_mpp_available: "Parser disponível",
    maint_mpp_unavailable: "Parser indisponível",
    maint_mpp_checking: "Verificando…",
    maint_mpp_reinit_btn: "Tentar reinstalar / reiniciar",
    maint_mpp_reinit_running: "Instalando Java + iniciando JVM (até 60s)…",
    maint_mpp_reinit_ok: "Parser MPP inicializado com sucesso",
    maint_mpp_reinit_fail: "Falha ao inicializar parser MPP",
    maint_mpp_libpath: "libjvm.so",
    maint_mpp_heap: "JVM heap max",
    maint_mpp_error: "erro",
    api_tokens_title: "API para Power BI",
    api_tokens_subtitle: "tokens estáveis para integração com BI tools (admin only)",
    token_created_label: "novo token criado",
    token_save_now_help: "⚠️ Copie este token AGORA. Ele não será exibido novamente — apenas o trecho mascarado fica visível na lista abaixo.",
    token_name_placeholder: "Ex.: Power BI Producao",
    token_create_btn: "Gerar Token",
    token_list_title: "Tokens existentes",
    token_list_empty: "Nenhum token ainda. Crie o primeiro usando o campo acima.",
    token_status_active: "ativo",
    token_status_revoked: "revogado",
    token_created_at: "criado em",
    token_last_used: "último uso",
    token_confirm_revoke: "Revogar este token? Aplicações Power BI que usam ele vão parar de funcionar imediatamente.",
    token_revoked: "Token revogado",
    token_copied: "Token copiado",
    copy: "Copiar",
    dismiss: "ok",
    token_powerbi_usage_title: "Como usar no Power BI",
    token_powerbi_advanced: "Em Avançado, adicione header",
    token_powerbi_endpoints: "Endpoints disponíveis",
    api_v2_title: "API v2 (recomendada) — integrações",
    diag_title: "Diagnóstico de projetos",
    projects_other_companies_hint: "Esta lista mostra apenas os projetos da empresa ativa. Há {count} projeto(s) em outras empresas — troque a empresa no menu lateral para vê-los (a API e os links de compartilhamento também são escopados por empresa).",
    diag_help: "Cruza cada projeto com a empresa dona, as versões importadas (e quantas geraram tarefas) e os links que o expõem. Use quando um projeto não aparecer na lista, na API ou no link público.",
    diag_run: "Rodar diagnóstico",
    diag_total: "projetos",
    diag_no_ready: "sem versão com tarefas",
    diag_other_company: "de outra empresa",
    diag_no_link: "fora de links",
    diag_only_issues: "Só com problemas",
    diag_search_placeholder: "Buscar por projeto ou empresa…",
    diag_empty: "Nenhum projeto com problema encontrado.",
    diag_badge_other_company: "outra empresa",
    diag_versions: "versões",
    diag_with_tasks: "com tarefas",
    diag_served: "servida nos links",
    diag_links: "link(s)",
    api_v2_docs_link: "Documentação Swagger",
    api_v2_resources: "Recursos",
    api_v2_schema_hint: "Catálogo de todos os atributos",
    api_v1_deprecated_title: "API v1 — DEPRECIADA",
    api_v1_deprecated_help: "Continua funcionando, mas não recebe novos campos nem novos objetos. Migre suas consultas para a v2 (mesma chave, header X-API-Key).",
    multi_apply: "Aplicar",
    multi_cancel: "Cancelar",
    multi_title: "Projetos & Versões",
    multi_project_placeholder: "Projeto…",
    multi_version_placeholder: "Versão…",
    multi_add_project: "Adicionar Projeto",
    // Public picker
    public_picker_viewing: "visualizando:",
    public_picker_all: "Todos os projetos do link",
    // Export
    export_png_failed: "Falha ao gerar PNG",
    export_nothing: "Nada para exportar.",
    export_rendering_many: "Renderizando {n} tarefas… isso pode levar alguns segundos.",
    export_too_large: "Diagrama muito grande para uma única imagem ({w}×{h}px). Reduza a quantidade de colunas visíveis ou aplique um filtro de período antes de exportar.",
    export_quality_reduced: "Diagrama grande — exportado com qualidade reduzida ({pct}%). Para qualidade total, filtre ou esconda colunas.",
    export_png_success: "PNG gerado",
    share_link_expired: "Link expirado",
    share_link_expired_help: "Este link de compartilhamento atingiu sua data de expiração. Solicite ao administrador um novo link.",
  },
  en: {
    app_name: "Cornerstone",
    by_company: "by GT Strategy",
    nav_dashboard: "Dashboard",
    nav_projects: "Projects",
    nav_settings: "Settings",
    nav_users: "Users",
    nav_logout: "Sign out",
    language: "Language",
    portuguese: "Português",
    english: "English",
    login_title: "Sign in to Cornerstone",
    login_subtitle: "Construction project schedule management.",
    email: "Email",
    password: "Password",
    name: "Name",
    company_name: "Company Name",
    login_submit: "Sign In",
    register_submit: "Create Account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    sign_up: "Sign up",
    sign_in: "Sign in",
    register_title: "Create new account",
    register_subtitle: "Start planning your projects in minutes.",
    dashboard_title: "Dashboard",
    dashboard_subtitle: "Overview of your projects.",
    total_projects: "Projects",
    total_syncs: "Versions",
    total_tasks: "Tasks",
    open_restrictions: "Open Restrictions",
    new_project: "New Project",
    recent_projects: "Recent Projects",
    no_projects: "No projects yet. Create your first project to get started.",
    projects_title: "Projects",
    create_project: "Create Project",
    project_name: "Project Name",
    description: "Description",
    location: "Location",
    client: "Client",
    start_date: "Start Date",
    end_date: "End Date",
    status: "Status",
    color: "Color",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    open: "Open",
    delete: "Delete",
    edit: "Edit",
    confirm_delete: "Confirm deletion? This action cannot be undone.",
    overview: "Overview",
    syncs: "Versions",
    gantt: "Gantt",
    kanban: "Kanban",
    line_of_balance: "Line of Balance",
    restrictions: "Restrictions",
    sharepoint: "SharePoint",
    project_settings: "Settings",
    setup_progress: "Setup Progress",
    next_step: "Next Step",
    completed: "completed",
    of: "of",
    upload_schedule: "Import Schedule",
    drop_files: "Drop the file here or click to select (.xml, .csv, .mpp)",
    sync_name: "Version Name",
    set_baseline: "Mark as Baseline",
    sync_reparse_tooltip: "Reparse file · re-runs the parser and re-populates custom fields (useful after parser upgrades)",
    sync_sharepoint_link_tooltip: "Open original file on SharePoint",
    sync_rename_tooltip: "Rename version",
    incomplete_versions_singular: "version looks incomplete after parser upgrade:",
    incomplete_versions_plural: "versions look incomplete after parser upgrade:",
    incomplete_breakdown_empty: "with no tasks (imported before native .mpp support)",
    incomplete_breakdown_cf_regression: "with lost custom columns (iter30 JVM regression)",
    incomplete_breakdown_missing_aliases: "without column aliases (legacy uploads)",
    reparse_all_incomplete_btn: "Reparse all",
    reparse_project_tooltip: "Reparse all versions of this project · re-runs the parser on each upload (.mpp/.xml/.csv) or re-downloads from SharePoint if local file is gone",
    reparse_company_btn: "Reparse everything",
    reparse_company_tooltip: "Reparse ALL versions of ALL projects in this company (super-admin / admin only)",
    confirm_reparse_project: "Reparse all versions of project \"{name}\"? May take a few minutes.",
    confirm_reparse_company: "Reparse ALL versions of ALL projects in \"{name}\"? May take a while depending on volume.",
    reparse_project_done: "{ok}/{total} project versions reparsed",
    reparse_company_done: "{ok}/{total} company versions reparsed",
    failed: "failed",
    notes: "Notes",
    no_syncs: "No schedule versions yet. Import your first file to get started.",
    version: "Version",
    tasks: "tasks",
    baseline: "Baseline",
    uploaded_by: "Imported by",
    compare_versions: "Compare Versions",
    select_baseline: "Select Baseline",
    select_target: "Select Target Version",
    no_tasks: "No tasks in this version.",
    pick_a_sync: "Select a schedule version on the left to view.",
    not_started: "Not started",
    in_progress: "In progress",
    late: "Late",
    completed_status: "Completed",
    critical_path: "Critical Path",
    show_critical_only: "Critical only",
    add_restriction: "New Restriction",
    title: "Title",
    category: "Category",
    responsible: "Owner",
    due_date: "Due Date",
    priority: "Priority",
    related_tasks: "Related Tasks",
    no_restrictions: "No restrictions yet.",
    sharepoint_config: "SharePoint Configuration",
    sharepoint_subtitle: "Connect your document library to auto-sync schedules.",
    tenant_id: "Azure AD Tenant ID",
    client_id: "Client ID",
    client_secret: "Client Secret",
    hostname: "SharePoint Hostname",
    site_relative_url: "Site URL",
    document_library: "Document Library",
    file_path: "File Path",
    folder_path: "Schedules Folder",
    folder_path_help: "Path of the SharePoint folder where .mpp/.xml/.csv files are stored. Ex: /Schedules",
    include_subfolders: "Include Subfolders",
    browse_files: "Browse Files",
    browsing: "Searching files…",
    files_found: "files found",
    no_files_found: "No schedule files (.mpp, .xml, .csv) found in this folder.",
    select_files_to_import: "Select the files to import as schedule versions. You can rename them before importing.",
    file_name: "File Name",
    rename_to: "Rename to",
    size: "Size",
    modified: "Modified",
    import_selected: "Import Selected",
    importing: "Importing…",
    already_imported: "Already imported",
    already_imported_short: "imported",
    collapse: "Collapse",
    expand: "Expand",
    files_short: "file",
    files_short_plural: "files",
    selected: "selected",
    select_all: "Select All",
    deselect_all: "Deselect All",
    set_as_baseline_short: "Baseline",
    step_credentials_title: "Credentials & Site",
    step_folder_title: "Schedules Folder",
    step_files_title: "File Mapping",
    company_sp_creds_title: "SharePoint Credentials (Azure AD)",
    company_sp_creds_subtitle: "Set up once per company. Used by every project.",
    library_url: "SharePoint Library URL",
    library_url_help: "Paste the library or folder URL from SharePoint. E.g. https://contoso.sharepoint.com/sites/Projects/Schedules",
    parsed_preview: "Parsed",
    edit_credentials: "Edit Credentials",
    not_configured: "Not configured",
    configured: "Configured",
    go_to_settings: "Go to Settings",
    sp_creds_missing_help: "Company Azure AD credentials must be configured before any project can use SharePoint.",
    company_sp_creds_saved: "Azure AD credentials saved successfully.",
    save_credentials: "Save Credentials",
    auto_sync: "Auto Sync",
    interval_min: "Interval (minutes)",
    test_connection: "Test Connection",
    save_config: "Save Configuration",
    sp_help: "To connect with SharePoint, register an Azure AD (Entra ID) app. Then fill in tenant_id, client_id, and client_secret.",
    // Live sync
    step_autosync_title: "Live Sync",
    autosync_subtitle: "Cornerstone fetches new schedules and updated versions straight from the SharePoint folder.",
    autosync_enable: "Enable auto sync",
    autosync_frequency: "Frequency",
    every: "Every",
    unit_hours: "hour(s)",
    unit_days: "day(s)",
    unit_months: "month(s)",
    every_5_min: "Every 5 minutes",
    every_15_min: "Every 15 minutes",
    every_30_min: "Every 30 minutes",
    every_hour: "Every hour",
    every_2_hours: "Every 2 hours",
    every_6_hours: "Every 6 hours",
    every_day: "Every 24 hours",
    last_sync_at: "Last sync",
    next_sync_at: "Next sync",
    last_sync_summary: "Summary",
    last_sync_error: "Error",
    sync_now_btn: "Sync now",
    syncing_now: "Syncing…",
    syncing_in_progress: "Sync in progress…",
    sync_files_new: "new",
    sync_files_updated: "updated",
    sync_files_skipped: "unchanged",
    sync_files_failed: "failed",
    sync_never_ran: "Never run yet",
    sync_success: "Sync complete",
    sync_failed: "Sync failed",
    sync_no_changes: "No changes detected",
    sync_in_progress_msg: "A sync is already running. Please wait.",
    sync_label_active: "active",
    sync_label_inactive: "inactive",
    time_ago: "{value}{unit} ago",
    time_in: "in {value}{unit}",
    ai_analysis: "AI Analysis",
    analyze: "Analyze",
    analyze_schedule_btn: "Analyze Schedule with AI",
    ai_subtitle: "Insights powered by Claude Sonnet 4.5",
    analysis_type: "Analysis Type",
    type_general: "General",
    type_critical: "Critical Path",
    type_bottlenecks: "Bottlenecks",
    type_delays: "Delays",
    type_optimization: "Optimization",
    type_inconsistencies: "Inconsistencies",
    summary: "Summary",
    critical_tasks: "Critical Tasks",
    bottlenecks: "Bottlenecks",
    delays_at_risk: "Delays at Risk",
    optimization_suggestions: "Optimization Suggestions",
    inconsistencies: "Inconsistencies",
    key_metrics: "Key Metrics",
    history: "History",
    generating: "Generating analysis…",
    extra_context: "Extra context (optional)",
    sync_comparator: "Sync Comparator",
    added: "Added",
    removed: "Removed",
    delayed: "Delayed",
    accelerated: "Accelerated",
    changed: "Changed",
    unchanged: "Unchanged",
    from: "From",
    to: "To",
    compare: "Compare",
    compare_with_ai: "Compare with AI",
    company_info: "Company Info",
    user_management: "User Management",
    invite_user: "Invite User",
    role: "Role",
    admin: "Admin",
    member: "Member",
    loading: "Loading…",
    error: "Error",
    share_track_latest_label: "Always latest version",
    share_track_latest_help: "Automatically adds the most recent synced version (SharePoint or manual upload) on top of the pinned versions you selected.",
    share_include_all_label: "All versions (automatic)",
    share_include_all_help: "Exposes EVERY version of this project in the API and public link — including versions created in the future, with no need to edit the link.",
    share_all_projects_label: "All projects (automatic)",
    share_all_projects_help: "This link starts serving EVERY project of the company, including projects created in the future. You can still pin specific versions for individual projects below.",
    share_all_projects_versions_label: "Serve all versions of each project (instead of only the latest)",
    share_all_projects_badge: "All projects",
    share_all_versions_badge: "All versions",
    share_effective_label: "Serving now",
    share_effective_empty: "No version available yet",
    share_live_badge: "Live",
    share_live_badge_tooltip: "This link always shows the most recent synced version of this project",
    success: "Success",
    nav_work_program: "Work Program",
    nav_share_links: "Share Links",
    nav_data: "Data",
    data_page_title: "Data Explorer",
    data_page_subtitle: "Every task from every project and version in one table. Filter by share link, project, or per-column. Click numeric column headers (marked Σ) to see totals.",
    data_admin_only: "Company admin access only.",
    data_filter_share_link: "Share link scope",
    data_filter_all_data: "All data",
    data_filter_exclude_share_links: "Exclude versions in share links",
    data_filter_project: "Project",
    data_filter_all_projects: "All projects",
    data_export_csv: "Export CSV",
    data_syncs_count: "versions",
    data_projects_count: "projects",
    data_toggle_sum: "Click to sum/average this column",
    no_data: "No data matches the current filters.",
    clear_filters: "Clear filters",
    clear: "clear",
    zoom_7d: "7 days",
    zoom_15d: "15 days",
    zoom_30d: "30 days",
    zoom_1y: "1 year",
    zoom_fit: "Fit",
    period: "Period",
    critical_path_short: "Critical",
    columns: "Columns",
    clear_filters: "Clear filters",
    clear_filters_title: "Clear all filters (columns, period, critical)",
    projects: "Projects",
    comparing: "Comparing",
    saved_views_btn: "Views",
    export_btn: "Export",
    versions_short: "v",
    col_task: "Task",
    col_id: "ID",
    col_start: "Start",
    col_finish: "Finish",
    col_duration_days: "Dur (d)",
    col_percent: "%",
    col_wbs: "WBS",
    col_outline_level: "Level",
    col_is_summary: "Summary",
    col_is_critical: "Critical",
    col_milestone: "Milestone",
    col_constraint_type: "Constraint",
    col_constraint_date: "Constraint Date",
    col_actual_start: "Actual Start",
    col_actual_finish: "Actual Finish",
    col_actual_duration: "Actual Duration",
    col_baseline_start: "Baseline Start",
    col_baseline_finish: "Baseline Finish",
    col_baseline_duration: "Baseline Duration",
    col_work_complete: "% Work",
    col_cost: "Cost",
    col_actual_cost: "Actual Cost",
    col_free_slack: "Free Slack",
    col_total_slack: "Total Slack",
    col_early_start: "Early Start",
    col_early_finish: "Early Finish",
    col_late_start: "Late Start",
    col_late_finish: "Late Finish",
    col_priority: "Priority",
    col_active: "Active",
    filter_search_placeholder: "search…",
    filter_all: "all",
    filter_selected_short: "selected",
    filter_select_all: "Select visible",
    filter_clear: "Clear",
    no_match: "No matches",
    tasks_n: "tasks",
    tasks_filtered_of: "filtered from",
    tasks_total: "tasks total",
    empty_no_tasks_version: "No tasks in this version.",
    empty_no_tasks_selection: "No tasks in this selection.",
    diff_vs_base: "vs base version:",
    diff_added: "New",
    diff_removed: "Removed",
    diff_delayed: "Delayed",
    diff_accelerated: "Accelerated",
    diff_clear: "clear filter ✕",
    columns_panel_section: "view",
    columns_drag_hint: "drag ⋮⋮ to reorder",
    columns_drag_handle_title: "Drag to reorder",
    columns_available_to_add: "Available to add",
    columns_width_px_title: "Column width in pixels",
    saved_views_title: "Saved Views",
    saved_views_read_only_subtitle: "read-only · published by your company",
    saved_views_name_placeholder: "View name",
    saved_views_scope_user: "Just me",
    saved_views_scope_company: "Whole company",
    saved_views_save: "Save",
    saved_views_empty: "No saved views yet.",
    saved_views_empty_public: "No views published by the company yet.",
    saved_views_loading: "Loading…",
    saved_views_name_required: "Please enter a name",
    saved_views_saved: "View saved",
    saved_views_loaded: "Loaded",
    saved_views_confirm_delete: "Delete this view?",
    saved_views_scope_label_company: "company",
    saved_views_scope_label_user: "user",
    export_title: "Export",
    export_csv_visible_title: "CSV — visible columns",
    export_csv_visible_desc: "Only currently displayed columns, all filtered rows.",
    export_csv_all_title: "CSV — all columns",
    export_csv_all_desc: "Includes hidden columns and custom fields.",
    export_png_title: "PNG Image — full Gantt",
    export_png_desc: "Exports all rows and the full schedule (off-screen), not just the on-screen viewport.",
    export_csv_visible_suffix: "visible",
    export_csv_all_suffix: "complete",
    export_failed_generic: "Failed to generate the image.",
    compare_title: "Compare with version",
    compare_help: "Overlay the selected version as a shadow (dashed line). Use to visualise delays / accelerations vs. baseline.",
    compare_project_label: "Project",
    compare_version_label: "Version",
    compare_clear: "Remove",
    compare_apply: "Apply",
    task_predecessors: "Predecessors",
    task_section_hierarchy: "Hierarchy",
    task_section_dates: "Dates",
    task_section_actuals: "Actuals",
    task_section_baseline: "Baseline",
    task_section_cpm: "CPM / Slack",
    task_section_resources: "Resources & Costs",
    task_section_meta: "Other",
    task_section_custom: "Custom Fields",
    task_section_label: "task",
    yes_short: "Yes",
    no_short: "No",
    multi_company_section: "multi-company",
    multi_company_pick_title: "Choose your company",
    multi_company_pick_help: "Your account is linked to more than one company. Select which context you want to enter.",
    super_admin_multi: "super-admin · multi-company",
    tenant_current: "current tenant",
    shared_view_label: "shared link",
    email_placeholder: "you@company.com",
    day_short: "day",
    maint_title: "Maintenance",
    maint_subtitle: "admin operations (admin only)",
    maint_recompute_title: "Recompute task ordering",
    maint_recompute_desc: "Re-numbers the `seq` field on every task using the tree-DFS algorithm, ensuring the hierarchy (parent → children) renders correctly in the Gantt and on share links. Idempotent — safe to re-run.",
    maint_recompute_company_btn: "Recompute (this company)",
    maint_recompute_all_btn: "Recompute ALL companies",
    maint_confirm_company: "Recompute ordering for ALL tasks of ALL syncs in this company? Safe and idempotent.",
    maint_confirm_all: "Recompute ordering for ALL tasks of ALL companies? Cluster-wide — super-admin only.",
    maint_done: "{syncs} syncs processed · {tasks} tasks updated",
    maint_mpp_title: "MPP Parser (Microsoft Project)",
    maint_mpp_desc: "Uploading `.mpp` files (MS Project's binary format) requires the JVM (Java 17) + MPXJ library on the backend. Status is auto-detected.",
    maint_mpp_available: "Parser available",
    maint_mpp_unavailable: "Parser unavailable",
    maint_mpp_checking: "Checking…",
    maint_mpp_reinit_btn: "Reinstall / restart",
    maint_mpp_reinit_running: "Installing Java + starting JVM (up to 60s)…",
    maint_mpp_reinit_ok: "MPP parser initialised successfully",
    maint_mpp_reinit_fail: "Failed to initialise MPP parser",
    maint_mpp_libpath: "libjvm.so",
    maint_mpp_heap: "JVM heap max",
    maint_mpp_error: "error",
    api_tokens_title: "Power BI API",
    api_tokens_subtitle: "stable tokens for BI tool integration (admin only)",
    token_created_label: "new token created",
    token_save_now_help: "⚠️ Copy this token NOW. It will not be shown again — only the masked portion remains visible in the list below.",
    token_name_placeholder: "e.g.: Power BI Production",
    token_create_btn: "Generate Token",
    token_list_title: "Existing tokens",
    token_list_empty: "No tokens yet. Create your first using the field above.",
    token_status_active: "active",
    token_status_revoked: "revoked",
    token_created_at: "created",
    token_last_used: "last used",
    token_confirm_revoke: "Revoke this token? Power BI apps using it will stop working immediately.",
    token_revoked: "Token revoked",
    token_copied: "Token copied",
    copy: "Copy",
    dismiss: "ok",
    token_powerbi_usage_title: "How to use in Power BI",
    token_powerbi_advanced: "Under Advanced, add header",
    token_powerbi_endpoints: "Available endpoints",
    api_v2_title: "API v2 (recommended) — integrations",
    diag_title: "Project diagnostics",
    projects_other_companies_hint: "This list only shows projects of the active company. There are {count} project(s) in other companies — switch company in the sidebar to see them (the API and share links are company-scoped too).",
    diag_help: "Cross-checks every project against its owning company, its imported versions (and how many produced tasks) and the links exposing it. Use it when a project is missing from the list, the API or the public link.",
    diag_run: "Run diagnostics",
    diag_total: "projects",
    diag_no_ready: "no version with tasks",
    diag_other_company: "from another company",
    diag_no_link: "not in any link",
    diag_only_issues: "Only with issues",
    diag_search_placeholder: "Search by project or company…",
    diag_empty: "No project with issues found.",
    diag_badge_other_company: "other company",
    diag_versions: "versions",
    diag_with_tasks: "with tasks",
    diag_served: "served in links",
    diag_links: "link(s)",
    api_v2_docs_link: "Swagger documentation",
    api_v2_resources: "Resources",
    api_v2_schema_hint: "Catalog of every attribute",
    api_v1_deprecated_title: "API v1 — DEPRECATED",
    api_v1_deprecated_help: "Still working, but it will not get new fields or new objects. Migrate your queries to v2 (same key, X-API-Key header).",
    multi_apply: "Apply",
    multi_cancel: "Cancel",
    multi_title: "Projects & Versions",
    multi_project_placeholder: "Project…",
    multi_version_placeholder: "Version…",
    multi_add_project: "Add Project",
    public_picker_viewing: "viewing:",
    public_picker_all: "All projects in this link",
    export_png_failed: "Failed to generate PNG",
    export_nothing: "Nothing to export.",
    export_rendering_many: "Rendering {n} tasks… this may take a few seconds.",
    export_too_large: "Chart too large for a single image ({w}×{h}px). Reduce visible columns or apply a period filter before exporting.",
    export_quality_reduced: "Large chart — exported at reduced quality ({pct}%). For full quality, filter or hide columns.",
    export_png_success: "PNG generated",
    share_link_expired: "Link expired",
    share_link_expired_help: "This share link has reached its expiration date. Please request a new link from the administrator.",
  },
};
